import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

import {
  IHandbook,
  IHandbookDetail,
  IHandbookExport,
  IHandbookFile,
  IHandbookRequestExport,
  IHandbookResponse,
} from '../models/interfaces/IHandbook';
import { Observable } from 'rxjs';

const { apiUrl } = environment;

@Injectable({
  providedIn: 'root',
})
export class HandbookService {
  constructor(private http: HttpClient) {}

  list(): Promise<IHandbook[]> {
    return this.http.get<IHandbook[]>(`${apiUrl}handbook/get-all`).toPromise();
  }

  geoJson(): Promise<any> {
    return this.http
      .get(
        'https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/brazil-states.geojson'
      )
      .toPromise();
  }

  download(value: IHandbookExport) {
    return this.http
      .post(`${apiUrl}handbook/export`, value, {
        responseType: 'blob',
        observe: 'response',
      })
      .toPromise();
  }

  requestDownload(value: IHandbookRequestExport) {
    return this.http
      .post(`${apiUrl}handbook/request-handbook`, value, {
        responseType: 'blob',
        observe: 'response',
      })
      .toPromise();
  }

  async get(id: string) {
    var response = this.http
      .get<IHandbookDetail>(`${apiUrl}handbook/${id}/get`)
      .toPromise();
    return response;
  }
}
